import './index.styl';
import _ from 'lodash';
import { View } from 'backbone.marionette';
import { Model } from 'backbone';
import Radio from "backbone.radio";
import { User } from "../../models";
import template from './index.jst';

import {
	TeamBuilder,
	TradePlayerPopup,
} from '../../views/Fantasy';

import { isAuthorized } from "../../../../core/utils";

const CHANNEL_TRADE = Radio.channel('trade');

export class StatsCentreView extends View {

	get template() {
		return template;
	}

	get className() {
		return 'page-trades';
	}

	regions() {
		return {
			pool: '.trade-pool',
			popup: '.trade-player-popup',
		}
	}

	childViewEvents() {
		return {
			'player:show:popup': 'onPlayerShowPopup',
			'player:favourite': 'onPlayerFavourite',
		}
	}

	initialize() {
		this.initListeners()
			.requestData();
	}

	initListeners() {
		this.listenTo(this, 'data:requested', this.onDataRequested);
		this.listenTo(this.model, 'update', this.getViewParams);

		return this;
	}

	get requestModels() {
		const isCoachEnabled = User.attributes.assistant_coach === 1;

		return _.pick(
			this.options,
			'squads', 'rounds', 'players',
			(isCoachEnabled ? 'coach' : null), 'venues',
			(isAuthorized() ? 'favourites' : null),
		)
	}

	async requestData() {
		await TeamBuilder.prototype.requestData.call(this);
	}

	getMappedPlayers() {
		return TeamBuilder.prototype.getMappedPlayers.call(this, ...arguments);
	}

	getRemainingSalary() {
		return TeamBuilder.prototype.getRemainingSalary.call(this, ...arguments);
	}

	getTeamProjectedScore() {
		return TeamBuilder.prototype.getTeamProjectedScore.call(this, ...arguments);
	}

	updateNotCountedPlayers() {
		return TeamBuilder.prototype.updateNotCountedPlayers.call(this, ...arguments);
	}

	getDoubleScoreLeaderId() {
		return null;
	}

	onDataRequested() {
		return TeamBuilder.prototype.onDataRequested.call(this);
	}

	getViewParams() {
		const params = TeamBuilder.prototype.getViewParams.call(this);
		CHANNEL_TRADE.trigger('data:changed', params);
	}

	onPlayerShowPopup(args) {
		TeamBuilder.prototype.onPlayerShowPopup.call(this, args);
	}

	getPlayerPopupView(args) {
		return new TradePlayerPopup({
			model: new Model({
				...args,
				bench_rank: null,
				is_from_bench: false,
				is_from_field: false,
				is_authorized: isAuthorized(),
			})
		});
	}

	async onPlayerFavourite(args) {
		await TeamBuilder.prototype.onPlayerFavourite.call(this, args);
		this.model.trigger('update');
	}
}

export default StatsCentreView;